import React, { useContext, memo } from 'react';
import { Select } from 'antd';
import { CountryContext } from '../../../repository/context/countryContext';

interface CountrySelectionProps {
  onCountryChange: Function;
}

const CountrySelection = (props: CountrySelectionProps) => {
  const { onCountryChange } = props;
  const countryContext = useContext(CountryContext);

  const handleChange = (item: string) => {
    if (onCountryChange) {
      onCountryChange(item);
    }
  };

  const options: any[] = countryContext?.countryList?.map(item => {
    return {
      value: item?.code,
      label: item?.name,
    };
  });

  return (
    <Select
      defaultValue="USA"
      style={{
        width: 150,
        marginRight: 20,
      }}
      onChange={handleChange}
      options={options}
    />
  );
};

export default memo(CountrySelection);
